import {
  SET_ARTWORKS,
  SET_SINGLE_ARTWORK,
  SET_ARTWORK_LOADING,
  SET_ARTWORK_ERROR
} from '../actionTypes'

const initialState = {
  artwork: null,
  artworks: null,
  loading: false,
  error: false
}

function artworkReducer(state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case SET_ARTWORKS:
      return { ...state, artworks: payload }
    case SET_SINGLE_ARTWORK:
      return { ...state, artwork: payload }
    case SET_ARTWORK_LOADING:
      return { ...state, loading: payload }
    case SET_ARTWORK_ERROR:
      return { ...state, error: payload }
    default:
      return state
  }
}

export default artworkReducer